import correct from "./assets/icons/correct.svg";
import wrong from "./assets/icons/wrong.svg";

export const free = [
  { feature: "Access to Basic Courses", status: correct },
  { feature: "Basic Customer Support", status: correct },
  { feature: "Video Courses", status: wrong },
  { feature: "The Certified Ethical Hacker Exam", status: wrong },
  { feature: "CEH study guides", status: wrong },
  { feature: "Sample questions banks", status: wrong },
  { feature: "Certified Information Security Manager Exams", status: wrong },
];

export const months4 = [
  { feature: "Self paced Certified Ethical Hacker Programme", status: correct },
  { feature: "The Certified Ethical Hacker Exam", status: correct },
  {
    feature: "Remote procturing for CEH will cost and individual $100",
    status: correct,
  },
  { feature: "Video Courses", status: correct },
  { feature: "CEH study guides", status: correct },
  { feature: "Sample questions banks", status: correct },
  { feature: "Flashcards and notebooks", status: correct },
  { feature: "Certified Information Security Manager Exams", status: correct },
];

export const months8 = [
  { feature: "Self paced Certified Ethical Hacker Programme", status: correct },
  { feature: "The Certified Ethical Hacker Exam", status: correct },
  {
    feature: "Remote procturing for CEH will cost and individual $100",
    status: correct,
  },
  { feature: "Video Courses", status: correct },
  { feature: "CEH study guides", status: correct },
  { feature: "Sample questions banks", status: correct },
  { feature: "Flashcards and notebooks", status: correct },
  { feature: "Certified Information Security Manager Exams", status: correct },
  { feature: "Certified Cloud Security Professional", status: correct },
  { feature: "CompTIA Security +", status: correct },
  { feature: "Exam Retakes", status: correct },
];
export const yearly = [
  { feature: "Self paced Certified Ethical Hacker Programme", status: correct },
  { feature: "The Certified Ethical Hacker Exam", status: correct },
  {
    feature: "Remote procturing for CEH will cost and individual $100",
    status: correct,
  },
  { feature: "Video Courses", status: correct },
  { feature: "CEH study guides", status: correct },
  { feature: "Sample questions banks", status: correct },
  { feature: "Flashcards and notebooks", status: correct },
  { feature: "Certified Information Security Manager Exams", status: correct },
  { feature: "Certified Cloud Security Professional", status: correct },
  { feature: "CompTIA Security +", status: correct },
  { feature: "Exam Retakes", status: correct },
];
// tools
export const starter = [
  { feature: "Core Impact", status: correct },
  { feature: "Invicti", status: correct },
  { feature: "Fortify", status: correct },
  { feature: "Cain & Abel", status: correct },
  { feature: "Network Mapper", status: correct },
];
export const standard = [
  { feature: "Cobalt Strike", status: correct },
  { feature: "Immunity CANVAS", status: correct },
  { feature: "Wireshark", status: correct },
  { feature: "Aircrack", status: correct },
  { feature: "Hydra", status: correct },
  { feature: "Sqlmap", status: correct },
  { feature: "Maltego", status: correct },
  { feature: "Nessus", status: correct },
];
export const pro = [
  { feature: "Rapid InsightVm", status: correct },
  { feature: "OWASP ZAP", status: correct },
  { feature: "GFI LanGuard", status: correct },
  { feature: "Netcat", status: correct },
  { feature: "WebInspect", status: correct },
  {feature: "Ettercap",status: correct,},
  { feature: "Recon", status: correct },
  { feature: "Browser Exploitation Framework (BeEF)", status: correct },
  { feature: "W3af", status: correct },
  {feature: "Burp Suite Professional",status: correct,},
];
